import React, {FC} from 'react';
import './style.scss';
import AddTastesButton from "../AddTastesButton";

interface ITastesBrand {
    name: string,
    id: number,
    tastesID: Array<number>
    handleMix: any,
    brandName: string
}

const ItemTastesBrand: FC<ITastesBrand> = ({
                                               name,
                                               id,
                                               handleMix,
                                               brandName,
                                               tastesID
                                           }) => {

        const isActive = tastesID.find((item: any) => item.id === id);
        const clickHandler = (id: number) => {
            handleMix(id, name, brandName, !isActive)
        };

        return (
            <div
                className="item-tastes-brand"
                onClick={() => clickHandler(id)}
            >
                <div className="item-tastes-brand__title">
                    {name}
                </div>
                <div className="item-tastes-brand__add">
                    <AddTastesButton
                        isActive={!!isActive}
                    />
                </div>
            </div>
        )
    }
;

export default ItemTastesBrand;
